export const JOURNEYS_LP_URL = 'https://lp.wabunka-lux.jp/all-wabunka-journeys';
